// EditLockHeartbeat — pings the LiveView every `data-interval` ms (default
// 30000ms = 30s) so it can call Seiva.EditLock.renew/3 and keep the lock
// alive while the editor tab is open. Stops on disconnect/unmount and resumes
// on reconnect.
//
// Usage: attach phx-hook="EditLockHeartbeat" to any element inside the
// editor view — typically a hidden <div>. The interval can be overridden
// via data-interval (in milliseconds).
//
//     <div phx-hook="EditLockHeartbeat" data-interval="30000" id="..." />
//
// The LiveView receives a "renew_edit_lock" event and is responsible for
// calling Seiva.EditLock.renew/3 with the right {kind, id} key.
export const EditLockHeartbeat = {
  mounted() {
    const interval = parseInt(this.el.dataset.interval || '30000', 10);
    this._stopped = false;
    this._tick = () => {
      if (this._stopped) return;
      this.pushEvent('renew_edit_lock', {});
    };
    this._timer = setInterval(this._tick, interval);
  },
  destroyed() {
    this._stopped = true;
    if (this._timer) clearInterval(this._timer);
  },
  disconnected() {
    if (this._timer) clearInterval(this._timer);
  },
  reconnected() {
    const interval = parseInt(this.el.dataset.interval || '30000', 10);
    this._timer = setInterval(this._tick, interval);
  }
};
